<rcl-section-header id="mock-login-section-header">
    <rcl-section-title id="mock-login-section-header__title">Welcome to Check-in Web</rcl-section-title>
    <rcl-section-description id="mock-login-section-header__description">Please begin your checkin process
    </rcl-section-description>
</rcl-section-header>
@if (accessTokenStatus() && olciDataStatus()) {
    <div class="rcl-row">
        <div class="custom-alert">
            <h5 class="rcl-h5">Cookies <span style="font-style: italic; font-weight: 800;"> AccessToken </span> and <span
                style="font-style: italic; font-weight: 800;"> OlciData </span> already exist, click <button id="mock-login-login-button"
                class="rcg-text-link" (click)="login()">here</button> to skip the login process. The validity of the
                AccessToken is not guaranteed.
            </h5>
            <button class="rcl-button-text" (click)="clearCookies()">Clear Cookies</button>
        </div>
    </div>
}
<div class="rcl-row">
    <h4 class="rcl-h4">To start your <span style="font-style: italic;font-weight: 800;"> check-in </span>process, you
        can fill out the form or simply paste the required cookies.</h4>
</div>
<div class="rcl-row">
    <button class="rcl-button-text collapsible" id="complete-form__button" [class.active]="formOption"
        (click)="expandCompleteForm()">Complete form</button>
</div>
@if (formOption) {
    <form id="login-form" [formGroup]="loginForm" novalidate>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'First Name'"
            [control]="'firstName'">
            @for (error of errors?.firstName; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Last Name'"
            [control]="'lastName'">
            @for (error of errors?.lastName; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Email'"
            [control]="'email'">
            @for (error of errors?.email; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'"
            [label]="'DOB mm/dd/yyyy'" [control]="'dob'">
            @for (error of errors?.dob; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'GA vdsId'"
            [control]="'vdsId'">
            @for (error of errors?.vdsId; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Guest Id'"
            [control]="'guestId'">
            @for (error of errors?.guestId; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Booking Id'"
            [control]="'bookingId'">
            @for (error of errors?.bookingId; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'"
            [label]="'Sail Date yyyy-mm-dd'" [control]="'sailDate'">
            @for (error of errors?.sailDate; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Ship Code'"
            [control]="'shipCode'">
            @for (error of errors?.shipCode; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
        <rcl-select class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [control]="'locale'" [id]="'locale'"
            [label]="'Locale'">
            @for (locale of localeArray; track locale) {
                <rcl-option
                    [ariaLabel]="'locale'" [id]="locale"
                    [value]="locale" [viewValue]="locale"></rcl-option>
            }
            @for (error of errors?.locale; track $index) {
                <rcl-error-message>{{ error }} </rcl-error-message>
            }
        </rcl-select>
    </div>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-6" [group]="loginForm" [type]="'text'" [label]="'Access Token'"
            [control]="'accessToken'">
            @for (error of errors?.accessToken; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
        <rcg-radio-group-v2
            class="rcl-col-sm-12 rcl-col-md-6"
            [mode]="brandName" 
            [disabled]="false" 
            [options]="charterOptionsString"
            [control]="'charterSailing'"
            [name]="'charterSailing'"
            [arialabel]="'Is Charter Sailing'"
            [value]="selectedCharterOption"
            (optionSelected)="onCharterOptionSelected($event)"
            [layout]="layout">
        </rcg-radio-group-v2>
        @for (error of errors?.charterSailing; track $index) {
            <rcl-error-message>{{ error }}</rcl-error-message>
        }
    </div>

    <div class="rcl-row" style="justify-content: flex-end;">
        <rcg-primary-button 
            type="button" 
            text="Continue" 
            (click)="saveFormValues()"
            (keydown.enter)="saveFormValues()"         
        ></rcg-primary-button>
    </div>
    </form>
}

<div class="rcl-row">
    <button class="rcl-button-text collapsible" id="paste-cookies__button" [ngClass]="{ 'active': cookiesOption }"
        (click)="expandPasteCookies()">Paste cookies</button>
</div>
@if (cookiesOption) {
    <form id="cookies-form" [formGroup]="cookiesForm" novalidate>
    <div class="rcl-row">
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-12" [group]="cookiesForm" [type]="'text'" [label]="'Olci Data*'"
            [control]="'olciData'">
            @for (error of errors?.olciData; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
        <rcl-text-field class="rcl-col-sm-12 rcl-col-md-12" [group]="cookiesForm" [type]="'text'"
            [label]="'Access Token*'" [control]="'accessToken'">
            @for (error of errors?.accessToken; track $index) {
                <rcl-error-message>{{ error }}</rcl-error-message>
            }
        </rcl-text-field>
        <div style="display: flex; flex-direction: column; margin-left: auto;" [ngStyle]="{'margin-bottom': feSsoChecked() ? '10px' : '60px'}">
            <rcg-input-checkbox-v2
                style="margin-left: auto; margin-bottom: 5px;"
                [checked]="feSsoChecked()"
                (isChecked)="onFeSsoChecked()"
                label="Enable fe sso field for GLC"
            ></rcg-input-checkbox-v2>
        </div>
        @if (feSsoChecked()) {
            <rcl-text-field class="rcl-col-sm-12 rcl-col-md-12" [group]="cookiesForm" [type]="'text'"
                [label]="'fe sso'" [control]="'feSso'">
            </rcl-text-field>
        }
    </div>

    <div class="rcl-row" style="justify-content: flex-end;">
        <rcg-primary-button 
            type="button" 
            text="Continue" 
            (click)="setCookies()"
            (keydown.enter)="setCookies()"
        ></rcg-primary-button>
    </div>
    </form>
}
<br />
<br />
<br />
